import React from 'react'
import classnames from 'classnames'

import styles from './DetailLayout.module.scss'

const DetailLayout = ({ children, className, showMap }) => (
  <div
    className={classnames(false && styles.root, className)} // TODO: don't really need this anymore
    children={children}
  />
)

export default DetailLayout
